
import type { PropType } from 'vue'
import type { PaymentRequest } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

import { defineComponent } from 'vue'

// > helpers/formatPriceToTenge <
import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    props: {
        paymentRequest: {
            type: Object as PropType<PaymentRequest>,
            required: true
        },
    },
    defineEmits: ['pay', 'decline'],
    setup(props, { emit }) {
        const getColor = () => {
            if (props.paymentRequest) {
                if (props.paymentRequest.status) {
                    if (props.paymentRequest.status.id === 60) {
                        return 'green'
                    }

                    if (props.paymentRequest.status.id === 61) {
                        return 'red'
                    }

                    if (props.paymentRequest.status.id === 62) {
                        return 'orange'
                    }
                }
            }

            return 'gray'
        }

        const onPay = () => emit('pay')
        const onDecline = () => emit('decline')

        return {
            getColor,
            formatPriceToTenge,
            onPay,
            onDecline
        }
    }
})
